import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import PaymentForm from './PaymentForm/PaymentForm';
import PaymentStatus from './PaymentStatus/PaymentStatus';

// const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
const stripePromise = loadStripe('pk_test_HSgnO1q1Qxx7E9quwjK8mwK4');

const PaymentsBase = () => {
  const location = useLocation();

  const options = {
    clientSecret: location.state?.clientId,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <Routes>
        <Route exact path="/" element={<PaymentForm />} />
        <Route exact path="/status" element={<PaymentStatus />} />
      </Routes>
    </Elements>
  );
};

export default PaymentsBase;
